<script>
export default {
    page() {
        return { title: 'Your Shows' } // title only — noindex page
    },
}
</script>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useStore } from '@state/composables'
import Layout from '@layouts/main'
import ShowGridBlock from '@components/show/show-grid-block'
import LibraryHeader from '@components/library/library-header'
import LibrarySearchResults from '@components/library/library-search-results'
import LibrarySectionTabs from '@components/library/library-section-tabs'

const store = useStore()
const searchQuery = ref('')
const followedShows = computed(() => store.getters['favorites/followedShows'])
const showsLoaded = computed(() => store.getters['favorites/isLoaded']('shows'))

onMounted(() => {
    store.dispatch('favorites/fetchType', 'shows').catch(error => {
        // leave `loaded` untouched — the spinner (not a false empty state) is the FR21 failure mode
        console.error('Failed to refresh followed shows', error)
    })
})
</script>

<template>
    <Layout>
        <BaseContent>
            <BaseSection padded>
                <LibraryHeader
                    title="Your Shows"
                    :count="showsLoaded ? followedShows.length : null"
                    count-label="shows"
                    :search-query="searchQuery"
                    @update:search-query="searchQuery = $event"
                />
                <LibrarySearchResults
                    v-if="searchQuery.trim()"
                    :query="searchQuery"
                />
                <template v-else>
                    <LibrarySectionTabs />
                    <BaseSpinner v-if="!followedShows.length && !showsLoaded" />
                    <ShowGridBlock
                        v-else-if="followedShows.length"
                        :shows="followedShows"
                    />
                    <BaseEmptyList
                        v-else
                        :error="{
                            title: 'You are not following any shows.',
                            paragraph: 'Following shows helps us recommend similar shows.',
                        }"
                    />
                </template>
            </BaseSection>
        </BaseContent>
    </Layout>
</template>
